/**
 * @generated SignedSource<<210c03b356af3558094d2187351cd5c9>>
 * @relayHash 9f8f716e33f0a3f70ec04be69edc8a8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 358acf927b5804a881bf1d24cc18e315f32b18ad94e0f7c7dcf94aa639b52072

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_FilterQuery$variables = {
  filterAri: string;
  includeFilter: boolean;
};
export type main_FilterQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_filterQuery">;
};
export type main_FilterQuery = {
  response: main_FilterQuery$data;
  variables: main_FilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeFilter"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "main_FilterQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "main_issueNavigator_IssueNavigator_filterQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "main_FilterQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "includeFilter",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "filterAri"
                  }
                ],
                "kind": "LinkedField",
                "name": "filter",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraFilter"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      }
                    ],
                    "type": "JiraCustomFilter"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "filterId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "358acf927b5804a881bf1d24cc18e315f32b18ad94e0f7c7dcf94aa639b52072",
    "metadata": {},
    "name": "main_FilterQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "181bb07a6bafd05a2033750384a06766";

export default node;
